import { Icon } from "@core/components/Icon";
import type { SafeHtmlAttributes } from "@core/types/SafeHtmlAttributes";

import type { DirectionalIconComponent } from "@jti/brand-icons";

import styles from "./QuantityInputItem.module.scss";

export type QuantityInputItemProps = {
  icon: DirectionalIconComponent;
  disabled?: boolean;
} & SafeHtmlAttributes<HTMLButtonElement>;

export const QuantityInputItem = ({ icon, disabled = false, ...rest }: QuantityInputItemProps) => (
  <button {...rest} type="button" tabIndex={-1} disabled={disabled} className={styles.quantityInputItem}>
    <Icon icon={icon} size="sm" />
  </button>
);
